import { GenericBackendResponse } from '../genericBackendResponse';

export const getHoldedInvoicePdf = async (
	token: string,
	docType: string,
	documentId: string
): Promise<
	GenericBackendResponse<{
		documentId: string;
		docType: string;
		pdfUrl: string;
		pdfContent: string;
		fileSize: number;
		contentType: string;
	}>
> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/thirdparty/holded/documents/${docType}/${documentId}/pdf-base64`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);
	return response.json();
};
